import { render } from "./Shadow.vue?vue&type=template&id=40c128c9"
import script from "./Shadow.vue?vue&type=script&lang=js"
export * from "./Shadow.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/enwan/enwan-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__